import React, { useState, useEffect } from 'react'; 
import './Comments.css';
import { useDispatch, useSelector } from 'react-redux';
import { getNote } from '../../../store/api'


export function Comments() {
  const dispatch = useDispatch()
  const {note, statusNote, errorNote} = useSelector(state => state.notes) 

  useEffect(() => {
    dispatch(getNote());
  }, []);

 console.log(note, statusNote)

  if (statusNote === 'loading') {
    return <div className="loading">Загрузка комментариев...</div>;
  }

  if (errorNote) {
    return <div className="error">{errorNote}</div>;
  }

  return (
    <div className="comments-container">
      <h2>Все комментарии к рецептам</h2>
      
      {note.length === 0 ? (
        <p>Комментарии не найдены</p>
      ) : (
        <div className="comments-list">
          {note.map((comment) => (
            <div key={comment._id} className="comment-card">
              <div className="comment-header">
                <h3 className="recipe-title">{comment.recipeTitle}</h3> 
              </div>
              
              <div className="comment-content">
                <p className="comment-text">{comment.text}</p>
              </div>
              
              <div className="comment-footer">
                <span className="comment-author">
                  Автор: {comment.authorName}
                </span>
                 <span className="comment-date">
                  {new Date(comment.createdAt).toLocaleDateString('ru-RU', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
   
} 